import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/AppShell";
import { ErrorScreen, LoadingScreen } from "./components/ScreenState";
import { api } from "./lib/api";
import { ApiError } from "./lib/api";
import { AuthPage } from "./pages/AuthPage";
import { AccountSecurityPage } from "./pages/AccountSecurityPage";
import { CapturePage } from "./pages/CapturePage";
import { HomeworkPage } from "./pages/HomeworkPage";
import { ProfilePage } from "./pages/ProfilePage";
import { ReportPage } from "./pages/ReportPage";
import { TodayPage } from "./pages/TodayPage";
import { LegalPage } from "./pages/LegalPage";

export function App() {
  const location = useLocation();
  const session = useQuery({ queryKey: ["session"], queryFn: api.session, staleTime: Infinity, retry: false });
  if (location.pathname.startsWith("/legal/")) {
    return <Routes><Route path="legal/terms" element={<LegalPage kind="terms" />} /><Route path="legal/privacy" element={<LegalPage kind="privacy" />} /><Route path="legal/children" element={<LegalPage kind="children" />} /><Route path="*" element={<Navigate to="/" replace />} /></Routes>;
  }
  if (session.isPending) return <LoadingScreen />;
  if (session.isError && session.error instanceof ApiError && session.error.status === 401) return <AuthPage />;
  if (session.isError) return <ErrorScreen message={session.error.message} onRetry={() => void session.refetch()} />;

  return (
    <Routes>
      <Route element={<AppShell />}>
        <Route index element={<TodayPage />} />
        <Route path="homeworks" element={<HomeworkPage />} />
        <Route path="capture" element={<CapturePage />} />
        <Route path="report" element={<ReportPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="account-security" element={<AccountSecurityPage />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
